// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import { configureInternalNavigationFromCMSUrl } from '@tcp/core/src/utils';
import Heading from '@tcp/core/src/components/common/atoms/Heading';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import styles, { StyledImageBannerWrapper, StyledCol } from './BrandPartners.style';

const BrandPartners = ({
  colSize,
  colIndex,
  imageBanner,
  l1Index,
  hideL2Nav,
  imgConfig,
  imgBannerLength,
  className,
  headerDesktop,
  headerMobile,
}) => {
  const renderHeader = (header) => {
    if (!header) return null;
    const [mainText, pillText] = header.split('|').map((text) => text.trim());
    return (
      <div className="l2-nav-category-header">
        <div className="l2-nav-header">
          <Heading variant="h6" className="l2-nav-category-heading" dataLocator="l2_col_heading_">
            {mainText}
          </Heading>
          {pillText && (
            <BodyCopy
              className={'pill'}
              component="span"
              fontFamily="secondary"
              fontSize="fs10"
              fontWeight="extrabold"
              color="white"
              lineHeight="lh115"
            >
              {pillText}
            </BodyCopy>
          )}
        </div>
        <span className="l2-nav-category-divider" />
      </div>
    );
  };

  return (
    <StyledCol
      className={`${className} l2-brand-partners l2-image-banner_${colIndex} `}
      colSize={{
        small: 6,
        medium: 8,
        large: colSize || 2,
      }}
      ignoreNthRule
    >
      {renderHeader(headerDesktop || headerMobile)}
      <StyledImageBannerWrapper>
        {imageBanner.map(({ image, link }, index) => (
          <React.Fragment>
            <Anchor
              className={`l2-image-banner-link l2-image-banner-link_${colIndex}_${index} l2-image-link-brand-partners`}
              to={configureInternalNavigationFromCMSUrl(link.url)}
              asPath={link.url}
              title={link.title}
              dataLocator={`overlay_img_link_${l1Index}`}
              target={link.target}
              onClick={() => hideL2Nav()}
            >
              <DamImage
                imgData={image}
                data-locator={`overlay_img_${l1Index}`}
                imgConfigs={imgConfig.crops}
                className={`l2-image-banner-image l2-image-banner-image_${colIndex}_${index} l2-image-brand-partners`}
              />

              {link?.text && (
                <BodyCopy
                  className={`l2-nav-link ${
                    imgBannerLength > 1 && index === 0 ? 'l2-nav-split-nav-link' : ''
                  } l2-nav-link-brand-partners`}
                  fontFamily="secondary"
                  fontSize={['fs12', 'fs12', 'fs12']}
                  lineHeight="lh107"
                  color="text.primary"
                  textAlign="center"
                >
                  <span className="nav-bar-l1-item-label">{link.text}</span>
                </BodyCopy>
              )}
            </Anchor>
          </React.Fragment>
        ))}
      </StyledImageBannerWrapper>
    </StyledCol>
  );
};

BrandPartners.propTypes = {
  colSize: PropTypes.number,
  colIndex: PropTypes.number.isRequired,
  imageBanner: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({}).isRequired,
      link: PropTypes.shape({
        url: PropTypes.string.isRequired,
        title: PropTypes.string,
        target: PropTypes.string,
        text: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
  l1Index: PropTypes.number.isRequired,
  hideL2Nav: PropTypes.func.isRequired,
  imgConfig: PropTypes.shape({}).isRequired,
  imgBannerLength: PropTypes.number.isRequired,
  className: PropTypes.string,
  headerDesktop: PropTypes.string,
  headerMobile: PropTypes.string,
};

BrandPartners.defaultProps = {
  colSize: 3,
  className: '',
  headerDesktop: '',
  headerMobile: '',
};

export { BrandPartners as BrandPartnersVanilla };
export default withStyles(BrandPartners, styles);
